// libraries
import { createGlobalStyle } from 'styled-components';

// js
import colors from './colors';
import consts from '../utils/consts';

// style
const globalStyle = createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        outline: 0;
        box-sizing: border-box;
    }
    body {
        background-color: #ffffff;
        -webkit-font-smoothing: antialiased;
    }
    body, input, button {
        font-size: ${consts.fontSize.default};
        font-family: ${consts.fontFamily};
        font-weight: ${consts.getFontWeight('Lato-Regular')};
        color: ${colors.basic.white};
    }
    #root {
        margin: 0 auto;
    }
`;

export default globalStyle;
